export const TABLE_HEADER_STYLE = {
  fontSize: 11,
  fontWeight: 700,
  textTransform: 'uppercase' as const,
  lineHeight: '16px',
};
